import { render, staticRenderFns } from "./SettlementsList.vue?vue&type=template&id=1e48d122&scoped=true"
import script from "./SettlementsList.vue?vue&type=script&lang=js"
export * from "./SettlementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e48d122",
  null
  
)

export default component.exports